import React from 'react';
import { motion } from 'framer-motion';
export const LiveScanTicker = () => {
  return <div className="bg-[#FF0000] text-[#FFD700] py-2 px-4 overflow-hidden relative z-50" data-id="element-2583" data-mp="35z4btypcs7sc">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 font-bold uppercase tracking-widest text-sm md:text-base" data-id="element-2584" data-mp="2rarg92u6gqyd">
        <motion.div animate={{
        opacity: [1, 0.5, 1]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className="w-3 h-3 bg-[#FFD700] rounded-full" data-id="element-2585" data-mp="2w89rx0zkxka2" />
        <span data-id="element-2586" data-mp="2m926dqioyjbv">LIVE · 10,000+ CONVERSATIONS ANALYZED · ENCRYPTED</span>
      </div>

      {/* Scan line effect overlay */}
      <motion.div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent" animate={{
      x: ['-100%', '100%']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-2587" data-mp="2da6wa3cj0p3a" />
    </div>;
};